/**
 * Applies fragment labels from a fragment molecule to a target molecule. This method is in
 * place and modifies the target molecule directly.
 *
 * The OpenChemLib library is recovered from the molecule itself via
 * `molecule.getOCL()`, so this package never imports `openchemlib` at
 * runtime (avoids version conflicts and keeps it out of consumer bundles).
 * @param molecule - The target molecule to which fragment labels will be applied.
 * @param fragment - The fragment molecule containing the labels to apply.
 * @param options
 * @returns The number of matches found
 */
export function applyFragmentLabels(molecule, fragment, options = {}) {
    const { algorithm = 'overlapping', prefix = '', suffix = '' } = options;
    const OCL = molecule.getOCL();
    const sssearcher = new OCL.SSSearcher();
    sssearcher.setMolecule(molecule);
    sssearcher.setFragment(fragment);
    const found = sssearcher.findFragmentInMolecule({ countMode: algorithm });
    const matches = sssearcher.getMatchList();
    for (const match of matches) {
        for (let fragmentAtomIndex = 0; fragmentAtomIndex < match.length; fragmentAtomIndex++) {
            const moleculeAtomIndex = match[fragmentAtomIndex];
            const label = fragment.getAtomCustomLabel(fragmentAtomIndex);
            if (label) {
                molecule.setAtomCustomLabel(moleculeAtomIndex, prefix + label + suffix);
            }
        }
    }
    return found;
}
//# sourceMappingURL=applyFragmentLabels.js.map